import "~/styles/global.css";

import { memo } from "react";

import { AppProps } from "./_type";
import { Popup } from "../features/popup";

import { AuthProvider } from "~/common/contexts/auth";
import { PopupProvider } from "~/common/contexts/knowledge";
import { AntdProvider } from "~/libs/antd";
import { SWRProvider } from "~/libs/swr";

export default memo(
  ({ portalContainer, styleContainer, ...props }: AppProps) => {
    return (
      <SWRProvider>
        <AuthProvider {...props}>
          <AntdProvider
            portalContainer={portalContainer}
            styleContainer={styleContainer}
          >
            <PopupProvider {...props}>
              <Popup />
            </PopupProvider>
          </AntdProvider>
        </AuthProvider>
      </SWRProvider>
    );
  },
);
